import React, { Component } from 'react';
import '../CSS/newRecord.css';
import GenericNavbar from './Navbar/GenericNavbar';

import SimpleStorageContract from "../contracts/SimpleStorage.json";
import getWeb3 from "../utils/getWeb3";

class Companylist extends Component{
    constructor(props){
        super(props);
        this.state = {user:'', users:[]}
    }

    componentDidMount = async () => {
        var user = localStorage.getItem("user");
        user = JSON.parse(user);
        if(user){
            this.setState({user:  user});
        }
        fetch(`http://52.60.64.107/api/orginatorx-new/get-all-compunys.php?methos=get_users`)
            .then(response => response.json())
            .then(data => {
                console.log(data)
                this.setState({users: data.result })
            })
      };


    render(){
        return(
            <div className = "">
                 <nav className="nav-wrapper grey darken-4 navbar">
            <div className="container">
            <a href="/" className="brand-logo">
                        <img
                            className="header__logo"
                            src="./logo.jpg"
                            alt="logo"
                            />
                            </a>
               <ul className = "right">
                   <li active><a href = "/sender">Home</a></li>
                   {/* <li active><a href = "javascript:void(0)">Electronics record
                   <ul>
                       <li><a href = "/sender">Sender</a></li>
                       <li active><a href = "/recipient">Recipient</a></li>
                        <li><a href = "/newRecord">Request Record</a></li>
                   </ul>
                   </a>
                   </li> */}
                    {this.state.user !='' && this.state.user.user_type =='0' &&
                    <>
                   <li><a href = "/sender">Sender</a></li>
                    <li active><a href = "/recipient">Recipient</a></li>
                    <li><a href = "/newRecord">Request Record</a></li>
                   <li active><a href = "/token">Token</a></li>
                   <li active><a href = "/coin">Coin</a></li>
                   <li active><a href = "/nft">NFT</a></li>
                   </>
                    }
                    {this.state.user !='' && this.state.user.user_type =='1' &&
                    <>
                   <li><a href = "/create-company">Company master</a></li>
                    <li active><a href = "/company-list">Company list</a></li>
                   </>
                    }
                   
                   <li><a href = "/">Log out</a></li>
               </ul>
            </div>

        </nav>
                <div className="container">
                <div className="row">
                    <div className="col s10">
                        <h3>User list</h3>
                        <table className='highlight'>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Company </th>
                                </tr>
                            </thead>
                            {this.state.users.length >0 &&
                            <tbody>
                                {this.state.users.map((user, key) => {
													return <tr key={key}>
                                                    <td>{ user.fullname } </td>
                                                    <td>{ user.email } </td>
                                                    <td>{ user.company_name } </td>
                                                </tr>;
												})}
                                {/* {this.state.users.map((user,key)=>{
                                <tr key={key}>
                                    <td>{ user.fullname } </td>
                                    <td>{ user.email } </td>
                                    <td>{ user.company_name } </td>
                                </tr>
                                })} */}
                                
                            </tbody>
                            }
                        </table>
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default Companylist;
